module.exports = __webpack_public_path__ + "static/site-mobile-7ca9d07027b2db7b7a7e885c673a430b.jpg";